import { Section } from '@shared/components/Section';
import { Ficha } from '@shared/components/moldes';
import { ValorPendente } from '@shared/components/Pendente';
import { RASCUNHO } from '@shared/lib/modo';
import { fichaTecnica } from '@curso/content/curso';

/**
 * A primeira aba.
 *
 * Quem decide inscrever a equipe não lê a narrativa, varre os fatos. Deixar
 * isso como a aba aberta por padrão é o que faz a página servir aos dois
 * leitores sem virar duas páginas.
 */
export function Resumo() {
  const linhas = fichaTecnica
    .filter((linha) => RASCUNHO || linha.valor !== null)
    .map((linha) => ({
      rotulo: linha.rotulo,
      valor: linha.valor ?? <ValorPendente>ainda não definido</ValorPendente>,
    }));

  return (
    <Section id="resumo" rotulo="Em resumo">
      <Ficha linhas={linhas} />
    </Section>
  );
}
